import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminOrderEventsPurchase.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminOrderRidePurchase' */ './component')],
	render: ([AdminOrderEventsPurchase]) => <AdminOrderEventsPurchase />,
};

export default routes;
